/**
 * localStorage-backed boolean UI preferences (nav collapsed, chat panel open).
 * Both helpers swallow storage failures (e.g. private browsing) so reading
 * falls back to the default and writing becomes a no-op.
 */

export function readStoredBooleanPreference(key: string): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    return window.localStorage.getItem(key) === "true";
  } catch {
    return false;
  }
}

export function writeStoredBooleanPreference(key: string, value: boolean) {
  try {
    window.localStorage.setItem(key, String(value));
  } catch {
    // Ignore storage failures
  }
}
